import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';

interface PdfViewerProps {
  fileUrl: string;
}

const PdfViewer = ({ fileUrl }: PdfViewerProps) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulamos carga para mostrar el spinner
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [fileUrl]);

  if (loading) return <CircularProgress />;

  return (
    <embed 
      src={fileUrl}
      type="application/pdf"
      style={{
        width: '100%',
        height: '80vh',
        border: 'none'
      }}
      title="PDF Viewer"
    />
  );
};

export default PdfViewer;